import React, { useState, useEffect, useMemo, useRef } from 'react'
import PropTypes from 'prop-types'
import { getModel } from '../../data/Model'
import loadUsers from './loadUsers'
import Modal from '../../generic/Modal'
import CreateUserForm from './CreateUserForm'
import UserList from './UserList'
import Loading from '../../generic/Loading'
import getUsers from './getUsers'

export default function Users({ client_ids }, context) {
	const [showCreateModal, setShowCreateModal] = useState(false)

	const openCreateUserModal = () => setShowCreateModal(true)
	const closeCreateUserModal = () => setShowCreateModal(false)

	const Model = getModel()
	const isLoading = Model.users.status.handle === 'loading'
	const isAdmin =
		Model.me && Model.me.data && Model.me.data.permission_level === 'admin'

	const clientIdsKey = useMemo(
		() => (Array.isArray(client_ids) ? client_ids.join(',') : ''),
		[client_ids]
	)

	const didLoadRef = useRef(false)

	useEffect(() => {
		if (didLoadRef.current) return
		if (!Array.isArray(client_ids) || client_ids.length === 0) return
		const model = getModel()
		const notLoaded =
			model &&
			model.users &&
			model.users.status &&
			model.users.status.handle === 'not-loaded'
		if (isAdmin && notLoaded) {
			didLoadRef.current = true
			loadUsers()
		}
	}, [clientIdsKey, isAdmin])

	return (
		<div id='account' className='container' style={{ paddingBottom: 200 }}>
			{isLoading && (
				<div
					style={{
						position: 'fixed',
						top: 0,
						bottom: 0,
						left: 0,
						right: 0,
						maxHeight: '100%',
						inset: 0,
						background: 'rgba(255, 255, 255, 0.65)',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						zIndex: 9998,
					}}
				>
					<div
						style={{
							borderRadius: 8,
							padding: 50,
							minWidth: 120,
							textAlign: 'center',
						}}
					>
						<Loading />
						<div style={{ marginTop: 24, fontSize: 24 }}>Loading...</div>
					</div>
				</div>
			)}

			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					gap: 40,
					marginTop: 60,
					width: '100%',
				}}
			>
				<div>
					<h1>{context.gettext('admin.settings.users')}</h1>
				</div>
			</div>

			<div style={{ marginTop: 40 }}>
				<UserList
					users={Model.users.data}
					clients={Model.clients}
					onCreateUserAction={openCreateUserModal}
				/>
			</div>

			{showCreateModal && (
				<Modal
					title={context.gettext('admin.settings.create_user')}
					onClose={closeCreateUserModal}
				>
					<CreateUserForm
						onSuccess={() => {
							closeCreateUserModal()
							getUsers()
							//loadUsers()
						}}
					/>
				</Modal>
			)}
		</div>
	)
}

Users.contextTypes = {
	gettext: PropTypes.func.isRequired,
}

Users.propTypes = {
	client_ids: PropTypes.array,
}
